<template>
    <div>
        <p class="pause-question" v-text="question"></p>
        <button v-text="updateSubscriptionText"
                @click.prevent="updateSubscription"
                class="btn btn--primary btn--full-width pause-primary--button">
        </button>
        <button v-text="continueToPauseText"
                @click.prevent="continueToPauseSubscription"
                class="btn btn--secondary btn--full-width pause-secondary--button">
        </button>
        <p class="error pause-error--message" v-if="errorMessage" v-text="errorMessage"></p>
    </div>
</template>

<script>
export default {
    name: 'PauseQuestion',
    props: {
        question: {
            type: String,
        },
        continueToPauseText: {
            type: String,
        },
        updateSubscriptionText: {
            type: String,
        },
        errorMessage: {
            type: String,
        },
    },
    methods: {
        updateSubscription() {
            this.$emit('input', 'update');
        },
        continueToPauseSubscription() {
            this.$emit('input', 'continue');
        },
    },
};
</script>

<style lang="scss" scoped>
    .pause-question {
        margin: 15px 0;
        text-align: left;
    }
    .pause-primary--button {
        margin: 10px 0 5px;
    }
    .pause-secondary--button {
        margin: 5px 0 20px;
    }
</style>
